import {
    RESET_STORE,
    SET_CURRENT_BUSINESS,
    SET_IS_MODAL_LOADING,
    SET_IS_MOBILE_MENU_OPEN,
    SET_POPUP,
    SET_LOOKUP_DATA,
    SET_IS_ADMIN,
    SET_IS_MOBILE_APP,
    SET_MOBILE_APP_WRAPPER_DATA,
    SET_RECAPTCHA,
    SET_PAGE_TYPE,
    SET_TZUR_POPUP,
    SET_TZUR_POPUP_CENTER,
    SET_SETTINGS,
    SET_CONFIG,
    SET_SELECTED_MONTH_GLOBAL,
    SET_REVIEWS_PAGE_DATA,
    SET_SINGLE_REVIEW_PAGE,
    RESET_REVIEWS_PAGE_DATA,
    SET_T_DATA,
    SET_IS_MOBILE,
    SET_NOTIFICATION,
    SET_OPEN_BIOMETRIC_AS_DEFAULT,
    SET_ADMIN_OTP_LOGIN_TEMP_DATA,
    SET_OTP,
    SET_HASH,
    SET_IS_IPHONE,
    SET_DELIVIARY_ORDERS,
    SET_FROM_LOGINPAGE
} from "./actionTypes";

import initialState from "core/store/initialState";
import * as Utils from "core/common/utils";
import { trySetReturnUrl } from "core/route";

const getByPayload = ({ state, payload }, fieldName, override = true) => ({
    ...state,
    [fieldName]: !Array.isArray(state[fieldName]) && state[fieldName] instanceof Object ? Object.assign({}, (override ? {} : state[fieldName]), payload) : payload
});

/**
 * This is our main reducer
 * the reducer will receive a state and an action
 * the reducer is responsible to return a new state by create a copy of the current state and return a new one
 * in case the app will became big we will need to have multiple reducers (like: AuthReducer, PostsReducer etc...)
 * anyway, we will always have only one global store (same as it is done in redux)
 * @param {} state - the current state
 * @param {*} action - the action type
 */
const Reducer = (state, action) => {
    const params = { state, payload: action.payload };
    switch (action.type) {
        case SET_CURRENT_BUSINESS:
            if(params?.payload?.is_zap_coupons){
               // trySetReturnUrl("/zap-coupons")
            }
            return getByPayload(params, "business");

        case SET_DELIVIARY_ORDERS:
            return getByPayload(params, "deliveryOrders");

        case SET_FROM_LOGINPAGE:
            return getByPayload(params, "fromLoginPage");

        case SET_IS_MODAL_LOADING:
            return getByPayload(params, "isModalLoading");

        case SET_IS_MOBILE_MENU_OPEN:
            return getByPayload(params, "isMobileMenuOpen");

        case SET_IS_ADMIN:
            return getByPayload(params, "isAdmin");

        case SET_IS_MOBILE_APP:
            return getByPayload(params, "isMobileApp");

        case SET_MOBILE_APP_WRAPPER_DATA:
            return getByPayload(params, "mobileAppWrapperData", false);

        case SET_OTP:
            return getByPayload(params, "otp", null);

        case SET_HASH:    
            return getByPayload(params, "hash", null);
        case SET_POPUP:
            return getByPayload(params, "popup", false);
        
        case SET_TZUR_POPUP:
            return getByPayload(params, "tzurPopup", false);

        case SET_TZUR_POPUP_CENTER:
            return getByPayload(params, "tzurPopupCenter", false);

        case SET_OPEN_BIOMETRIC_AS_DEFAULT:
            return getByPayload(params, "openBiometricAsDefault", false);

        case SET_NOTIFICATION:
            return getByPayload(params, "notification", false);

        case SET_LOOKUP_DATA:
            return getByPayload(params, "lookup");

        case SET_SELECTED_MONTH_GLOBAL:
            return getByPayload(params, "selectedMonthGlobal");

        case SET_RECAPTCHA:
            return getByPayload(params, "recaptcha", false);

        case SET_PAGE_TYPE:
            return getByPayload(params, "pageType");

        case SET_REVIEWS_PAGE_DATA:
            return getByPayload(params, "reviewsPageData", false);

        case SET_IS_MOBILE:
            return getByPayload(params, "isMobile");

        case SET_IS_IPHONE:
            return getByPayload(params, "isIPhone");

        case SET_ADMIN_OTP_LOGIN_TEMP_DATA:
            return getByPayload(params, "adminOtpLoginTempData");

        case SET_T_DATA:
            const { payload: T } = action;

            return {
                ...state,
                T: (key) => {
                    return T?.[key] || key;
                }
            };

        case SET_SETTINGS:
            const { payload: settings } = action;
            return {
                ...state,
                settings: {
                    requestFromOffice: settings.requst_is_from_office,
                    recaptureEnabled: settings.recapture_enabled,
                    soundEnabled: settings.soundEnabled ?? true,
                    pingPeriodMiliseconds: settings.pingPeriodMiliseconds ?? 5000
                }
            };

        case SET_CONFIG:
            const { payload: cfg } = action;

            if (cfg) {

                const idelTimeoutMs = cfg.idle_timeout_minutes * 60 * 1000;

                return {
                    ...state,
                    cfg: {
                        isSystemAdmin: cfg.system,
                        idleTimeout: idelTimeoutMs,
                        businessOverviewAdmin:cfg.business_overview_admin
                    }
                };
            } else {
                return { ...state }
            }

        case SET_SINGLE_REVIEW_PAGE:
            const { targetReview, obj } = action.payload;
            const { currentVerticalTab } = state.reviewsPageData;

            const result = {
                ...state,
                reviewsPageData: {
                    ...state.reviewsPageData,
                    reviews: {
                        ...state.reviewsPageData.reviews,
                        [currentVerticalTab]: state.reviewsPageData.reviews[currentVerticalTab].map(review => {
                            return review.id !== targetReview.id ? review : { ...review, ...(obj || {}) };
                        })
                    }
                }
            };
            return result;

        case RESET_REVIEWS_PAGE_DATA:
            return {
                ...state,
                reviewsPageData: null
            };
        case RESET_STORE:
            return Object.assign(initialState, {
                lookup: state.lookup,
                recaptcha: state.recaptcha,
                mobileAppWrapperData: state.mobileAppWrapperData,
                globalEventEmitter: state.globalEventEmitter,
                isMobileApp: state.isMobileApp,
                T: state.T,
                settings: state.settings,
                config: state.config,
                isMobile: Utils.isMobile(),
                hash: state.hash
            });
        default:
            return state;
    }
};

export default Reducer;
